import config from 'src/config'
import helpers from 'src/helpers'

function load(component) {
  return () => import(`src/${component}.vue`)
}

let path = name => helpers.makeStringConcatenation('modules.autoship', name)

const MODULE_PATH = '/autoship/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Autoship Management',
    meta: {
      title: path('autoshipManagement.title'),
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.autoship,
      icon: 'autorenew',
    },
    children: [
      {
        path: MODULE_PATH + 'autoship/list',
        component: load('application/autoship/components/AutoshipLists'),
        name: 'Autoship List',
        meta: {
          title: path('autoshipList.title'),
          menuItem: true,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'autoship/new',
        component: load('application/autoship/components/AutoshipOrderArea'),
        name: 'New Autoship',
        meta: {
          title: path('newAutoship.title'),
          menuItem: false,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'autoship/view/[:subscriptionID]',
        component: load('application/autoship/components/AutoshipOrderArea'),
        name: 'View Autoship',
        props: true,
        meta: {
          title: path('viewAutoship.title'),
          menuItem: false,
          sorting: 5003,
        },
      },
    ],
  },
]
